/* eslint-disable import/no-extraneous-dependencies */
import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  IconButton,
  Menu,
} from '@material-ui/core';
import {
  Menu as MenuIcon,
  Person as AccountIcon,
  ArrowBack as ArrowBackIcon,
} from '@material-ui/icons';

import classNames from 'classnames';

// styles
import { useQuery } from '@apollo/client';
import { AuthService } from 'services/Auth/AuthService';
import useStyles from './styles';
import logo from '../../assets/images/logo.png';

// components
import { Typography } from '../Wrappers/Wrappers';
import Profile from '../Profile';

// context
import { GET_USER_BY_ID } from '../../queries/user';
import { useUserData } from '../../hooks/context/userUserData.hook';
import { useSideBarOpened } from '../../hooks/context/useSideBarOpened.hook';

export default function Header() {
  const classes = useStyles();

  const [isSidebarOpened, toggleSidebar] = useSideBarOpened();

  const [profileMenu, setProfileMenu] = useState(null);

  const [{ id, role, name, email }] = useUserData();

  const { loading: loadingUser, error: errorUser, data: dataUser } = useQuery(GET_USER_BY_ID, {
    variables: { id },
  });

  if (errorUser) {
    AuthService.logout();
    return <>Error</>;
  }

  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <IconButton
          color="inherit"
          onClick={toggleSidebar}
          className={classNames(
            classes.headerMenuButton,
            classes.headerMenuButtonCollapse,
          )}
        >
          {isSidebarOpened ? (
            <ArrowBackIcon
              classes={{
                root: classNames(
                  classes.headerIcon,
                  classes.headerIconCollapse,
                ),
              }}
            />
          )
            : (
              <MenuIcon
                classes={{
                  root: classNames(
                    classes.headerIcon,
                    classes.headerIconCollapse,
                  ),
                }}
              />
            )}
        </IconButton>
        <Typography
          variant="h6"
          weight="medium"
          className={classes.logotype}
        >
          <img
            src={logo}
            alt="logo"
          />
          <small>Content</small>
          <small className={classes.betaLabel}> BETA</small>
        </Typography>
        <div className={classes.grow} />

        <IconButton
          aria-haspopup="true"
          color="inherit"
          className={classes.headerMenuButton}
          aria-controls="profile-menu"
          onClick={e => setProfileMenu(e.currentTarget)}
        >
          <AccountIcon classes={{ root: classes.headerIcon }} />
        </IconButton>

        <Menu
          id="profile-menu"
          open={Boolean(profileMenu)}
          anchorEl={profileMenu}
          onClose={() => setProfileMenu(null)}
          className={classes.headerMenu}
          classes={{ paper: classes.profileMenu }}
          disableAutoFocusItem
        >
          <div className={classes.profileMenuUser}>
            <Typography variant="h4" weight="medium">
              {name}
            </Typography>
            <Typography variant="h6" weight="medium">
              <strong>{role}</strong>
            </Typography>
            <Typography
              className={classes.profileMenuLink}
              component="a"
              color="primary"
            >
              {email}
            </Typography>
          </div>
          {
            (loadingUser ? <div>Loading</div>
              : errorUser ? <div>Error</div>
                : <Profile dataUser={dataUser} />
            )
          }
          <div className={classes.profileMenuUser}>
            <Typography
              className={classes.profileMenuLink}
              color="primary"
              onClick={() => AuthService.logout(true)}
            >
              Sign Out
            </Typography>
          </div>
        </Menu>
      </Toolbar>
    </AppBar>
  );
}
